export const textTran: any = {
    us: {
        btnText: 'Sign Up',
        placeholder: 'Enter Your Email',
        tipsEmpty: 'Please enter the email.',
        tipsTypeError: 'Please enter a valid email address.',
        successTips: 'Subscription successful !',
        tipsCheck: 'Please consent to the Terms of Use and Privacy Policy.',
    },
    ca: {
        btnText: 'Sign Up',
        placeholder: 'Enter Your Email',
        tipsEmpty: 'Please enter the email.',
        tipsTypeError: 'Please enter a valid email address.',
        successTips: 'Subscription successful !',
        tipsCheck: 'Please consent to the Terms of Use and Privacy Policy.',
    },
    eu: {
        btnText: 'Sign Up',
        placeholder: 'Drop Your Email',
        tipsEmpty: 'Please enter the email.',
        tipsTypeError: 'Please enter a valid email address.',
        successTips: 'Sign up successful.',
        tipsCheck: 'Please consent to the Terms of Use and Privacy Policy.',
    },
    uk: {
        btnText: 'Sign Up',
        placeholder: 'Drop Your Email',
        tipsEmpty: 'Please enter the email.',
        tipsTypeError: 'Please enter a valid email address.',
        successTips: 'Sign up successful.',
        tipsCheck: 'Please consent to the Terms of Use and Privacy Policy.',
    },
    de: {
        btnText: 'Anmelden',
        placeholder: 'E-Mail-Adresse eingeben',
        tipsEmpty: 'Bitte geben Sie die E-Mail Adresse ein.',
        tipsTypeError: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
        successTips: 'Registrierung erfolgreich',
        tipsCheck: 'Bitte akzeptieren Sie die Nutzungsbedingungen und die Datenschutzerklärung.',
    },
    fr: {
        btnText: "S'abonner",
        placeholder: 'Adresse e-mail',
        tipsEmpty: "Veuillez saisir l'adresse e-mail.",
        tipsTypeError: 'Veuillez saisir une adresse e-mail valide.',
        successTips: 'Inscription réussie.',
        tipsCheck: "Veuillez accepter les conditions d'utilisation et la politique de confidentialité.",
    },
    it: {
        btnText: 'Iscriviti',
        placeholder: 'Comunicaci il tuo indirizzo e-mail',
        tipsEmpty: 'Inserisci il tuo indirizzo email.',
        tipsTypeError: 'Inserisci un indirizzo e-mail valido.',
        successTips: 'Iscrizione riuscita.',
        tipsCheck: "Accettate le Condizioni d'uso e l'Informativa sulla privacy.",
    },
    es: {
        btnText: 'Registrarse',
        placeholder: 'Ingresa tu correo',
        tipsEmpty: 'Ingresa el correo.',
        tipsTypeError: 'Ingresa un correo válido.',
        successTips: 'Registro exitoso.',
        tipsCheck: 'Acepta los Términos de uso y la Política de privacidad.',
    },
};

export const termsTran: any = {
    us: 'I consent to the <a href="https://us.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',
    ca: 'I consent to the <a href="https://ca.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',
    eu: 'I consent to the <a href="https://eu.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Use</a> and <a href="https://eu.ecoflow.com/policies/privacy-policy" target="_blank">Privacy Policy</a>.',
    uk: 'I consent to the <a href="https://uk.ecoflow.com/policies/terms-of-service" target="_blank">Terms of Use</a> and <a href="https://uk.ecoflow.com/policies/privacy-policy" target="_blank">Privacy Policy</a>.',
    de: 'Ich stimme den <a href="https://de.ecoflow.com/policies/terms-of-service" target="_blank">Nutzungsbedingungen</a> und der <a href="https://de.ecoflow.com/policies/privacy-policy" target="_blank">Datenschutzerklärung</a> zu.',
    fr: "J'accepte les <a href='https://fr.ecoflow.com/policies/terms-of-service' target='_blank'>Conditions d'utilisation</a> et la <a href='https://fr.ecoflow.com/policies/privacy-policy' target='_blank'>Politique de confidentialité</a>.",
    it: 'Acconsento ai  <a href="https://it.ecoflow.com/policies/terms-of-service" target="_blank">Termini di utilizzo</a> e all’ <a href="https://it.ecoflow.com/policies/privacy-policy" target="_blank">Informativa sulla privacy</a>.',
    es: 'Acepto los <a href="https://es.ecoflow.com/policies/terms-of-service" target="_blank">Términos de uso</a> y la <a href="https://es.ecoflow.com/policies/privacy-policy" target="_blank">Política de privacidad</a>.',
};
